import { render, staticRenderFns } from "./AvlHolder.vue?vue&type=template&id=cab02b32&scoped=true"
import script from "./AvlHolder.vue?vue&type=script&lang=js"
export * from "./AvlHolder.vue?vue&type=script&lang=js"
import style0 from "./AvlHolder.vue?vue&type=style&index=0&id=cab02b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab02b32",
  null
  
)

export default component.exports